import React from 'react';
import { Button, Space, Tag } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import { formatDate } from '../../utils/dateUtils';
import type { Order } from './types';
import {
  exceptionStatusColors,
  exceptionStatusLabels,
  resolveStatusColor,
  resolveStatusText,
} from './orderStatus';

type OrderColumnHandlers = {
  productDetailLoadingId: number | null;
  actionLoadingId: number | null;
  onShowDetail: (order: Order) => void;
  onShowProduct: (productId: number) => void;
  onManualSync: (order: Order) => void;
  onRetry: (order: Order) => void;
};

export const createOrderColumns = ({
  productDetailLoadingId,
  actionLoadingId,
  onShowDetail,
  onShowProduct,
  onManualSync,
  onRetry,
}: OrderColumnHandlers): ColumnsType<Order> => [
  { title: '订单号', dataIndex: 'orderNo', width: 150 },
  {
    title: '来源',
    dataIndex: 'sourcePlatform',
    width: 60,
    render: (platform) => (
      <Tag color={platform === '172' ? 'orange' : 'blue'} style={{ margin: 0 }}>
        {platform === '172' ? '172' : '号易'}
      </Tag>
    ),
  },
  {
    title: '产品ID',
    dataIndex: 'productId',
    width: 80,
    render: (productId) => (
      <Button
        type="link"
        size="small"
        loading={productDetailLoadingId === productId}
        onClick={() => onShowProduct(productId)}
        style={{ padding: 0 }}
      >
        {productId || '-'}
      </Button>
    ),
  },
  { title: '姓名', dataIndex: 'name', width: 80 },
  { title: '手机号', dataIndex: 'phone', width: 110 },
  {
    title: '状态',
    dataIndex: 'status',
    width: 120,
    render: (_, record) => <Tag color={resolveStatusColor(record)}>{resolveStatusText(record)}</Tag>,
  },
  { title: '平台状态', dataIndex: 'platformStatus', ellipsis: true, width: 120, render: (value?: string) => value || '-' },
  {
    title: '异常',
    dataIndex: 'exceptionStatus',
    width: 120,
    render: (value?: string) => value ? (
      <Tag color={exceptionStatusColors[value] || 'default'}>{exceptionStatusLabels[value] || value}</Tag>
    ) : '-',
  },
  { title: '消息', dataIndex: 'platformMsg', ellipsis: true, width: 180 },
  { title: '时间', dataIndex: 'createdAt', width: 140, render: (time) => formatDate(time) },
  {
    title: '操作',
    width: 210,
    render: (_, record) => (
      <Space size={4} wrap>
        <Button type="link" icon={<EyeOutlined />} onClick={() => onShowDetail(record)}>
          详情
        </Button>
        <Button type="link" loading={actionLoadingId === record.id} onClick={() => onManualSync(record)}>
          同步
        </Button>
        <Button
          type="link"
          danger={record.exceptionStatus === 'needs_manual_retry' || record.status === 'failed'}
          loading={actionLoadingId === record.id}
          onClick={() => onRetry(record)}
        >
          重提
        </Button>
      </Space>
    ),
  },
];
